import styled, { createGlobalStyle } from 'styled-components';
import {
  getAlignmentHorizontal,
  getAlignmentVertical,
} from '../../utils/alignment';

export const GlobalStyle = createGlobalStyle`
  body {
    background-color: rgba(0,0,0,0);
  }
`;

export const AdVideo = styled.video`
  position: absolute;
  z-index: 100;
`;
AdVideo.displayName = 'AdVideo';

export const Container = styled.div`
  align-items: ${({ alignment }) => getAlignmentVertical(alignment)};
  display: flex;
  justify-content: ${({ alignment }) => getAlignmentHorizontal(alignment)};
  height: 100vh;
`;
Container.displayName = 'Container';
